import { http } from './http'

export interface Stats {
  vouchers: {
    voucherCode: string
    count: number
  }[]
}

export const getVouchersStats = async ({
  startTime,
  endTime,
  festivalEditionId,
}: {
  startTime?: number
  endTime?: number
  festivalEditionId: string
}) =>
  http.get<Stats>(`/operations/stats/vouchers`, {
    params: {
      startTime,
      endTime,
      festivalEditionId,
    },
  })

export interface TicketsStats {
  items: {
    ticket: string
    category: string
    count: number
  }[]
}

export const getTicketsStats = async ({
  startTime,
  endTime,
  locale,
  festivalEditionId,
}: {
  startTime?: number
  endTime?: number
  locale?: string
  festivalEditionId: string
}) =>
  http.get<TicketsStats>(`/operations/stats/tickets`, {
    params: {
      startTime,
      endTime,
      locale,
      festivalEditionId,
    },
  })

export interface SalesStats {
  granularity: 'MONTH' | 'DAY' | 'HOUR'
  items: {
    amount: number
    date: number
  }[]
  soldTicketsCount: number
}

export const getSlatesStats = async ({
  startTime,
  endTime,
  locale,
  festivalEditionId,
}: {
  startTime?: number
  endTime?: number
  locale?: string
  festivalEditionId: string
}) =>
  http.get<SalesStats>(`/operations/stats/sales`, {
    params: {
      startTime,
      endTime,
      locale,
      festivalEditionId,
    },
  })

export interface PaymentMethodsStats {
  fiat: number
  crypto: number
}

export const getPaymentMethodsStats = async ({
  startTime,
  endTime,
  festivalEditionId,
}: {
  startTime?: number
  endTime?: number
  festivalEditionId: string
}) =>
  http.get<PaymentMethodsStats>(`/operations/stats/payment-methods`, {
    params: {
      startTime,
      endTime,
      festivalEditionId,
    },
  })

export interface CountriesStats {
  items: {
    country: string
    count: number
  }[]
}

export const getCountriesStats = async ({
  startTime,
  endTime,
  festivalEditionId,
}: {
  startTime?: number
  endTime?: number
  festivalEditionId: string
}) =>
  http.get<CountriesStats>(`/operations/stats/countries`, {
    params: {
      startTime,
      endTime,
      festivalEditionId,
    },
  })
